import Icon from '../components/Icon.vue'

Icon.register({
  terminal: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M258 273L63.6 467.3C54.3 476.7 39.1 476.7 29.7 467.3L7 444.6C-2.3 435.3-2.3 420.1 7 410.7L161 256 7 101.3C-2.3 91.9-2.3 76.7 7 67.4L29.7 44.7C39.1 35.3 54.3 35.3 63.6 44.7L258 239C267.4 248.4 267.4 263.6 258 273zM640 456V424C640 410.7 629.3 400 616 400H312C298.7 400 288 410.7 288 424V456C288 469.3 298.7 480 312 480H616C629.3 480 640 469.3 640 456z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/terminal.js
// module id = LQX9
// module chunks = 144